// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"944b15ac","239":"bb1e2b45","667":"61826410","867":"af3dd691"}[chunkId] + ".chunk.js";
};